import { type MutableRefObject, useCallback, useEffect, useRef, useState } from "react";

interface UseVideoControls {
    videoRef: MutableRefObject<HTMLVideoElement | null>;
    togglePlaying: () => void;
    scrubForward: () => void;
    scrubBackward: () => void;
}

export const useVideoControls = (src: string): UseVideoControls => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playing, setPlaying] = useState(true);

    const togglePlaying = useCallback(() => {
        if (playing) {
            setPlaying(false);
            videoRef.current?.pause();
        } else {
            setPlaying(true);
            videoRef.current?.play().catch(() => {
                // TODO - Error handling
            });
        }
    }, [videoRef, playing, setPlaying]);

    const scrubForward = useCallback(() => {
        if (videoRef.current && Number.isFinite(videoRef.current.duration)) {
            if (videoRef.current.currentTime + 0.25 < videoRef.current.duration) {
                videoRef.current.currentTime += 0.25;
            } else {
                videoRef.current.currentTime = videoRef.current.duration;
            }
        }
    }, [videoRef]);

    const scrubBackward = useCallback(() => {
        if (videoRef.current) {
            if (videoRef.current.currentTime - 0.25 >= 0) {
                videoRef.current.currentTime -= 0.25;
            } else {
                videoRef.current.currentTime = 0;
            }
        }
    }, [videoRef]);

    useEffect(() => {
        if (videoRef.current && src !== videoRef.current.src) {
            videoRef.current.load();
        }
    }, [videoRef, src]);

    return { videoRef, togglePlaying, scrubForward, scrubBackward };
};
